import { useEffect, useState } from "react";

import rocketSrc from "assets/images/rocket.png";
import rocketHoverSrc from "assets/images/hover/rocket-hover.png";
import checkroadmapSrc from "assets/images/bubbleText/checkroadmap.png";
import kitchenSrc from "assets/images/kitchen.png";
import kitchenHoverSrc from "assets/images/hover/kitchen-hover.png";
import buymerchSrc from "assets/images/bubbleText/buymerch.png";
import comingsoonSrc from "assets/images/bubbleText/comingsoon.png";
import iglooSrc from "assets/images/igloo.png";
import iglooHoverSrc from "assets/images/hover/igloo-hover.png";
import dragonSrc from "assets/images/dragon.png";
import dragonHoverSrc from "assets/images/hover/dragon-hover.png";
import comingSoonSrc from "assets/images/bubbleText/comingsoon.png";
import boxContainerSrc from "assets/images/container.png";
import boxContainerHoverSrc from "assets/images/hover/container-hover.png";
import buysausageSrc from "assets/images/bubbleText/buysausage.png";
import barbarSrc from "assets/images/bar.png";
import barbarHoverSrc from "assets/images/hover/bar-hover.png";
import joindiscordSrc from "assets/images/bubbleText/joindiscord.png";
import mapBg from "assets/images/bgnew.png";
import bigBoxFrontSrc from "assets/images/wienerBox/bigBoxFront.png";
import bigBoxBackSrc from "assets/images/wienerBox/bigBoxBack.png";
import smallBoxFrontSrc from "assets/images/wienerBox/smallBoxFront.png";
import smallBoxBackSrc from "assets/images/wienerBox/smallBoxBack.png";
import wienerSrc from "assets/images/wienerBox/wiener.png";

const ImgList = [
  rocketSrc,
  rocketHoverSrc,
  checkroadmapSrc,
  kitchenSrc,
  kitchenHoverSrc,
  buymerchSrc,
  comingsoonSrc,
  iglooSrc,
  iglooHoverSrc,
  dragonSrc,
  dragonHoverSrc,
  comingSoonSrc,
  boxContainerSrc,
  boxContainerHoverSrc,
  buysausageSrc,
  barbarSrc,
  barbarHoverSrc,
  joindiscordSrc,
  mapBg,
  bigBoxFrontSrc,
  bigBoxBackSrc,
  smallBoxFrontSrc,
  smallBoxBackSrc,
  wienerSrc,
];

export const useFetchImg = () => {
  const [isImgLoading, setIsImgLoading] = useState(true);
  useEffect(() => {
    async function fetchImg() {
      const promises = ImgList.map((imgSrc) => {
        return new Promise((resolve, reject) => {
          const imgEl = new Image();
          imgEl.src = imgSrc;
          imgEl.onload = () => resolve(true);
          imgEl.onerror = () => reject(false);
        });
      });
      await Promise.all(promises);
      setIsImgLoading(false);
    }
    fetchImg();
  }, []);

  return { isImgLoading };
};
